module.exports = __webpack_public_path__ + "static/media/service-saaas.815c5a54.png";